// extracted by mini-css-extract-plugin
module.exports = {"ProjectsDrawerItems":"ProjectsDrawerItems_ProjectsDrawerItems__LYI7E"};